import React from 'react'
import store from '../store/Store'

import EditorUser from '../components/editorUser/EditorUser'

import { Redirect, withRouter } from 'react-router-dom'

import './editorTemplateView.scss'

type editorTemplateState = {
	article: any;
	navigation: any;
	history: any;
}

type editorTemplateProps = {
	article: any;
	navigation: any;
	history: any;
}

class EditorUserView extends React.Component<editorTemplateState, editorTemplateProps> {

	constructor(props) {
		super(props)

		console.log(this.props)
		console.log(this.props.history)

		this.state = {
			history: props.history,
			article: store.getState().article,
			navigation: store.getState().navigation
		}
	}

	componentDidMount() {
		store.subscribe(() => {
			this.setState({
				article: store.getState().article,
				navigation: store.getState().navigation
			})
		})
	}

	componentWillUnmount() {
		store.subscribe(() => {
			this.setState({
				article: store.getState().article,
				navigation: store.getState().navigation
			})
		})
	}

	componentDidUpdate() {
		
	}

	render() {
		const { 
			article, 
			navigation,
			history
		} = this.state

		console.log(article)
		console.log(navigation)

		return (
			<div 
				className='EditorUserView'
				style={{
		    		minWidth: '100vw',
		    		width: '100vw',
		    		minHeight: '100vh',
		    		height: '100vh'
		    	}}
			>

		        <EditorUser
		          article={ article }
		          navigation={ navigation }
		          history={ history }
		        />

			</div>
		)
	}
}

export default withRouter(EditorUserView)